module.exports = __webpack_public_path__ + "assets/img/TermsBAIOS.552aa306.png";